import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import Dialog from '../../components/Dialog';
import ModalTuitionView from './ModalTuitionView';
import useExternalSettings from '@/presentation/hooks/useExternalSettings';

interface IProps {
  setShow: () => void;
  show: boolean;
  showTutorial?: boolean;
}

const ModalTuitionController = ({ setShow, show, showTutorial }: IProps) => {
  const [waitTutorial, setWaitTutorial] = useState(true);
  const [profile, setProfile] = useState({});

  const { data } = useSelector((state: any) => state.profileTurn);
  const { data: dataModality } = useSelector(
    (state: any) => state.modalityOfStudy
  );
  const {
    enrollmentPeriodName: periodDesc,
    enrollmentStartClasses: startClassText,
    enrollmentEndEnrollment: endEnrolmentText
  } = useExternalSettings();

  const enrolmentAppointment = data?.enrolmentAppointment;
  const modalityOfStudy = dataModality;

  useEffect(() => {
    if (showTutorial === undefined) setWaitTutorial(true);
    if (showTutorial === false) setWaitTutorial(false);
  }, [showTutorial, waitTutorial]);

  useEffect(() => {
    if (waitTutorial === false && data && data?.enrolmentAppointment) {
      setProfile(data.profile);
    }
  }, [waitTutorial, data]);

  if (!enrolmentAppointment) return null;
  return (
    <Dialog show={show} zIndex={1000} maxWidth="360px" handlerClose={setShow}>
      <ModalTuitionView
        profile={profile}
        modalityOfStudy={modalityOfStudy}
        enrolmentAppointment={{
          ...enrolmentAppointment,
          periodDesc,
          endEnrolmentText,
          startClassText
        }}
      />
    </Dialog>
  );
};
export default ModalTuitionController;
